// Constants
import { FINANCIAL_DATA_PROPS } from '../constants/pre-contract.view.constants';
// Translations
import { INFORMATION_TITLE } from '../translations/pre-contract.view.translations';
// Types
import { ContractHookType } from 'containers/contract/hooks/types/contract.hook.type';
import { FinancialDataComponentType } from 'containers/contract/components/financial-data/types/financial-data.component.type';

const getPreContractFinancialConfig = ({
  financialData,
  accounts,
}: Pick<ContractHookType, 'accounts' | 'financialData'>): FinancialDataComponentType => ({
  ...FINANCIAL_DATA_PROPS,
  data: financialData,
  title: INFORMATION_TITLE,
  showLink: accounts?.length > 1,
  showTooltip: accounts?.length === 1,
});

export { getPreContractFinancialConfig };
